import curd from '../curd'

const BASE_PATH = '/env/factor/category'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/EnvCategory.js